export default class LocalStorageName {
  static ACCOUNT_INFO_NAME = 'the-kingdom-accountInfo';
  static USER_ID_NAME = 'the-kingdom-userId';
  static ACCESS_TOKEN_NAME = 'the-kingdom-access';
}
